export default __webpack_public_path__ + "static/media/step_1.c56b06ab.svg";